
(function () {
  'use strict';
  angular.module('vctracker')
    .component('trackervalueeditor', {
      restrict: 'E',
      bindings: {
        trackervalue: '<?',
        trackervalueid: '<?'
      },
      template: `
        <trackervalueform trackervalue="vm.trackervalue" parentsave="vm.childsave(trackervalue)" oncancel="vm.oncancel()">
        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> trackervalue erfolgreich gespeichert!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen trackervalue wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> trackervalue konnte nicht gespeichert werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Trackervalue', 'Rlog',
        function ($log, Trackervalue, Rlog) {
          let vm = this;
          vm.save = save;
          vm.childsave = childsave;
          vm.oncancel = oncancel;
          
          vm.$onInit = function () {
            if ((angular.isUndefined(vm.trackervalue) || !vm.trackervalue.hasOwnProperty('_id'))
              && angular.isDefined(vm.trackervalueid)) {
              Trackervalue.$find(vm.trackervalueid).$then(function (trackervalue) {
                vm.trackervalue = trackervalue;
              }, function (err) {
                $log.error('trackervalue not found, id: ', vm.trackervalueid);
                Rlog.error('trackervalue', 'trackervalueeditor', 'trackervalue not found', {_id: vm.trackervalueid});
              });
            }
          };
          
          function childsave(trackervalue) {
            // vm.trackervalue = angular.copy(trackervalue);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in trackervalue) {
              if (trackervalue.hasOwnProperty(key)) {
                vm.trackervalue[key] = trackervalue[key];
              }
            }
            vm.save();
          }
          
          function save() {
            if (vm.trackervalue.$hasPendingActions()) {
              vm.trackervalue.$cancel();
              vm.trackervalue.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of trackervalue failed: ', err);
                Rlog.error('vcutils.trackervalue', 'trackervalueeditor', 'Saving of trackervalue failed: ', {error: err, trackervalueid: vm.trackervalue._id});
              });
            }
            else {
              vm.trackervalue.$save().$then(function () {
                vm.saved = true;
              }, function (err) {
                vm.saved = false;
                $log.error('saving of trackervalue failed: ', err);
                Rlog.error('vcutils.trackervalue', 'trackervalueeditor', 'Saving of trackervalue failed: ', {error: err, trackervalueid: vm.trackervalue._id});
              });
            }
          }
          
          function oncancel() {
            vm.canceled = true;
          }
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());